import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { pick } from 'lodash-es';
var props = function props() {
  return {
    query: {
      type: Function,
      required: true
    }
  };
};
var useFetchResources = function useFetchResources(_ref) {
  var query = _ref.query;
  var $axios = useNuxtApp().nuxt2Context.$axios;
  var $cancelTokenSource = null;
  var request = null;
  var resources = ref([]);
  var loading = ref(false);
  var pagination = ref({
    total: null,
    per_page: null,
    current_page: null
  });
  var fetchResources = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var filter, orderBy, page, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            filter = _ref2.filter, orderBy = _ref2.orderBy, page = _ref2.page;
            // Cancel previous request.
            if ($cancelTokenSource) {
              $cancelTokenSource.cancel();
            }
            loading.value = true;
            $cancelTokenSource = $axios.CancelToken.source();
            _context.prev = 4;
            request = query().applyFilters(filter).page(page).orderBy(orderBy);
            _context.next = 8;
            return request.getWithCancelToken($cancelTokenSource.token);
          case 8:
            response = _context.sent;
            resources.value = response.data;
            pagination.value = pick(response.meta, ['total', 'per_page', 'current_page']);
            $cancelTokenSource = null;
            _context.next = 20;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            if (!$axios.isCancel(_context.t0)) {
              _context.next = 19;
              break;
            }
            resources.value = [];
            return _context.abrupt("return");
          case 19:
            // @ts-ignore
            $axios.handleError(_context.t0);
          case 20:
            _context.prev = 20;
            loading.value = false;
            return _context.finish(20);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 14, 20, 23]]);
    }));
    return function fetchResources(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    fetchResources: fetchResources,
    resources: resources,
    loading: loading,
    pagination: pagination
  };
};
export { props, useFetchResources };